import * as CryptoJS from 'crypto-js';
import { reverseReplaceString } from './demo';
import icons from 'currency-icons';

const getDspDetails = (selectedProfile, masterAccountFilter) => {
  if (!selectedProfile || !selectedProfile?.dsp || selectedProfile?.dsp?.length === 0) {
      return null;
  }

  if (
      masterAccountFilter &&
      selectedProfile?.profileId &&
      masterAccountFilter[selectedProfile?.profileId] &&
      masterAccountFilter[selectedProfile?.profileId].length > 0
  ) {
      const selectedDspId = masterAccountFilter[selectedProfile?.profileId]?.find((item) => item?.level === "dsp")?.keywords;
      const selectedDspAccount = selectedProfile?.dsp?.find((item) =>
          Array.isArray(selectedDspId) && selectedDspId?.length > 0
              ? item?.dspId === selectedDspId?.[0]
              : item?.dspId === String(selectedDspId)
      );

      return selectedDspAccount || selectedProfile?.dsp?.[0];
  }

  return selectedProfile?.dsp?.[0];
};

export const getUserIdentity = (path = '', customGroupInfo = {}, customProfileId = null) => {
    const authUser = JSON.parse(localStorage.getItem('User'))
    const getProfile = customProfileId ? customProfileId : JSON.parse(sessionStorage.getItem('selectedProfileId'));
    // const getProfileIds = JSON.parse(localStorage.getItem('active-profiles-ids'))
    const isFlipkart = window.location.href.indexOf('/flipkart') > -1
    const isInstamart = window.location.href.indexOf('/instamart') > -1
    const isMyntra = window.location.href.indexOf('/myntra') > -1
    const isBlinkit = window.location.href.indexOf('/blinkit') > -1
    const isAmazon = window.location.href.indexOf('/amazon') > -1
    const isAmazonDSP = window.location.href.indexOf('/amazon-dsp') > -1
    const flipkartProfile = JSON.parse(sessionStorage.getItem('flipkartProfile'))
    const myntraProfile = JSON.parse(sessionStorage.getItem('myntraProfile'))
    const blinkitProfile = JSON.parse(sessionStorage.getItem('blinkitProfile'))
    const instamartProfile = JSON.parse(sessionStorage.getItem('instamartProfile'))
    const isZepto = window.location.href.indexOf('/zepto') > -1
    const zeptoProfile = JSON.parse(sessionStorage.getItem('zeptoProfile'))
    const isBigbasket = window.location.href.indexOf('/bigbasket') > -1
    const bigbasketProfile = JSON.parse(sessionStorage.getItem('bigbasketProfile'))

    const globalProfile = isFlipkart ? flipkartProfile : isAmazon ? getProfile : isMyntra ? myntraProfile : isInstamart ? instamartProfile : isBlinkit ? blinkitProfile : isZepto ? zeptoProfile : isBigbasket ? bigbasketProfile : {}
    const masterFilter = JSON.parse(sessionStorage.getItem('master-account-filters')) || {}
    const allMasterAccounts = JSON.parse(sessionStorage.getItem('all-accounts-profiles')) || []
    const accountFilterTabs = JSON.parse(sessionStorage.getItem('account-filter-tabs')) || []
    const isTodayApplied = (window.location.href.includes('snapshot') || window.location.href.includes('master-overview')) &&  accountFilterTabs?.some((item) => item?.eventKey === 'ad_account' && item?.fieldType === 'radio')
    const selectedAccountId = isTodayApplied && masterFilter && masterFilter?.[getProfile?.profileId] && masterFilter?.[getProfile?.profileId].length ? String(masterFilter?.[getProfile?.profileId]?.find((item) => item?.level === 'ams' && item?.keywords?.length > 0)?.keywords) : null
    const marketingStreamDetails = selectedAccountId && allMasterAccounts && allMasterAccounts?.find((item) => String(item?.profileId) === selectedAccountId) || {}

    console.log("marketingStreamDetails", {masterFilter, accountFilterTabs, selectedAccountId, isTodayApplied, allMasterAccounts, marketingStreamDetails});
    const dspDetails = getProfile?.dsp ? getDspDetails(getProfile, masterFilter) :{};

    
    const encryptionObject = {
      email: authUser?.email || '',
      role: globalProfile ?  globalProfile.accessLevel : 'Admin',
      profileId: globalProfile ? globalProfile.profileId : null,
      ...(isAmazon ? {
        region: getProfile && getProfile.marketplace ? getProfile.marketplace : null,
        datasetId: getProfile && getProfile.datasetId ? getProfile.datasetId : null
      } : {}),
      ...(isAmazonDSP ? {
        region: getProfile && getProfile?.marketplace ? getProfile?.marketplace : null,
        datasetId: getProfile && getProfile?.datasetId ? getProfile?.datasetId : null,
        dspdatasetId: dspDetails?.dspdatasetId,
        client: dspDetails?.dspClientName,
        dspId: dspDetails?.dspId,
        enabledAsOnlyDSP: dspDetails?.enabledAsOnlyDSP
      } : {}),
      ...(getProfile && 'client_email' in getProfile && getProfile.client_email ? { client_email: getProfile.client_email } : {
        ...getProfile && 'clientEmail' in getProfile && getProfile.clientEmail ? { client_email: getProfile.clientEmail } : {}
      }),
      profile: [],
      // ...(getProfileIds ? { profile: getProfileIds} : { profile: []}),
      // ...(authUser && authUser?.email == process.env.REACT_APP_ADMIN_ACCESS_EMAIL ? { profile: [] } : {}),
      ...(isFlipkart ? { client: flipkartProfile?.Value || '' } : isMyntra ? { client: myntraProfile?.Value || '' } : isBlinkit ? { client: blinkitProfile?.Value || '' } : isInstamart ? { client: instamartProfile?.Value || '' } : isZepto ? { client: zeptoProfile?.Value || '' } : isBigbasket ? { client: bigbasketProfile?.Value || '' } : {} ),
      ownerEmail: globalProfile && globalProfile?.profileOwner ? globalProfile?.profileOwner : authUser?.email,
      countryCode: globalProfile?.countryCode || '',
      currencyCode: globalProfile?.currencyCode || '',
      ...(getProfile && 'accountInfo' in getProfile &&  getProfile.accountInfo && globalProfile?.accountInfo?.marketplaceStringId ? { marketPlaceId: globalProfile?.accountInfo?.marketplaceStringId || '' } : {}),
      ...((isAmazon && !isAmazonDSP) && getProfile && 'accountInfo' in getProfile &&  getProfile.accountInfo ? { client: `${String(getProfile.accountInfo.name).replace(/ /g,'').toLocaleLowerCase()}-${String(getProfile.accountInfo.type).toLocaleLowerCase()}` } : {}),
      ...(getProfile && getProfile?.marketingStream && Object.keys(getProfile?.marketingStream).length > 0 && window.location.href.indexOf('amazon') > -1 ? { marketingStream: getProfile?.marketingStream } : {}),
      ...(dspDetails && dspDetails?.DSPMarketingStream && Object.keys(dspDetails?.DSPMarketingStream).length > 0 && window.location.href.indexOf('amazon') > -1 ? { DSPMarketingStream: dspDetails?.DSPMarketingStream } : {}),
      ...(customGroupInfo && customGroupInfo?.marketingStream && Object.keys(customGroupInfo?.marketingStream).length > 0 && window.location.href.indexOf('amazon') > -1 ? { marketingStream: customGroupInfo?.marketingStream } : {}),
      ...(globalProfile?.ams?.groupedAccounts && globalProfile?.ams?.groupedAccounts?.length > 0 ? { groupedProfileIds: globalProfile?.ams?.groupedAccounts?.map((item) => item.profileId)} : {}),
      ...(isTodayApplied && marketingStreamDetails && marketingStreamDetails?.marketingStream && Object.keys(marketingStreamDetails?.marketingStream).length > 0 && window.location.href.indexOf('amazon') > -1 ? { marketingStream: marketingStreamDetails?.marketingStream } : {}),
      ...(icons[getProfile?.currencyCode ? getProfile?.currencyCode : "INR"]?.symbol ? { currencySymbol: icons[getProfile?.currencyCode ? getProfile?.currencyCode : "INR"]?.symbol } : {}),
      ...(getProfile && '7DayAttributionData' in getProfile && window.location.href.indexOf('amazon') > -1 ? { '7DayAttributionData': getProfile?.['7DayAttributionData'] } : {}),
      ...(globalProfile && 'timezone' in globalProfile ? { 'timezone': globalProfile?.['timezone'] } : {}),
      ...(isFlipkart && globalProfile && 'V2' in globalProfile && globalProfile?.['V2'] == true ? { 'v2': globalProfile?.['V2'] } : {}),
      ...(isFlipkart && globalProfile && 'report_type' in globalProfile  ? { 'report_type': globalProfile?.['report_type'] } : {})
    }

    let newPayload = encryptionObject

    if(process.env.REACT_APP_DEMO_EMAIL && process.env.REACT_APP_DEMO_EMAIL.indexOf(authUser?.email) > -1) {
      const jsonString = JSON.stringify(newPayload);
      const newString = reverseReplaceString(jsonString)
      newPayload = JSON.parse(newString)   
    }

    console.log(`encryptionObjectmarketingStreamdatasetId ${path}`, encryptionObject)

    return dataEncrypt(newPayload)
}

export const dataEncrypt = (DATA) => {
  return CryptoJS.AES.encrypt(JSON.stringify(DATA), process.env.REACT_APP_CRYPTO_KEY).toString()
};

export const dataDecrypt = (DATA) => {
  return CryptoJS.AES.decrypt(decodeURIComponent(DATA), process.env.REACT_APP_CRYPTO_KEY);
};

export const dataStringEncrypt = (DATA) => {
  return CryptoJS.AES.encrypt(DATA, process.env.REACT_APP_CRYPTO_KEY).toString()
};

export const dataStringDecrypt = (DATA) => {
  return CryptoJS.AES.decrypt(decodeURIComponent(DATA), process.env.REACT_APP_CRYPTO_KEY);
};



export const loadScript = (src) => {
  return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
          resolve(true);
      };
      script.onerror = () => {
          resolve(false);
      };
      document.body.appendChild(script);
  });
}
